var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('LoadingContainer'):_c('div',[_c('ListPanel',{attrs:{"portal":_vm.portal,"primary-menu-link":_vm.primaryMenuLink}}),_vm._v(" "),_c('FormPanel',{attrs:{"initial":_vm.primaryMenuLink.attributes,"headline":"Edit Primary Menu Link","errors":_vm.errors},on:{"submit":_vm.submit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }